<template>
  <div class="mobile-menu">
    <button
      class="mobile-menu__trigger"
      @click="handleMenuBtnClick(true)"
      :title="$t('mobile.menu.trigger-title')"
      :aria-label="$t('mobile.menu.trigger-description')"
      type="button"
    >
      <svg
        width="22"
        height="22"
        viewBox="0 0 22 22"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <rect
          y="10"
          width="22"
          height="2"
          rx="1"
          fill="#fff"
        />
        <rect
          y="4"
          width="22"
          height="2"
          rx="1"
          fill="#fff"
        />
        <rect
          y="16"
          width="22"
          height="2"
          rx="1"
          fill="#fff"
        />
      </svg>
    </button>
    <!--    <div class="mobile-menu__geo-popup-wrap">-->
    <!--      <geo-header :hidden="true"></geo-header>-->
    <!--    </div>-->
    <div v-if="isVisible"
         class="mobile-menu__wrapper"
         :style="{ 'height': menuHeight }"
         :class="{ 'mobile-menu__wrapper--open': isOpen }">
      <div class="mobile-menu__wrapper-close"></div>
      <div class="mobile-menu__language-wrap">
        <a :href="urlLanguagePrefix + '/'" class="mobile-menu__logo">
          <img src="/img/svgo/dnipro-m-logo-black.svg" :alt="$t('logo.title')">
        </a>
        <mobile-menu-language></mobile-menu-language>
      </div>
      <div class="mobile-menu__profile-wrap">
        <mobile-menu-profile></mobile-menu-profile>
      </div>
      <div class="mobile-menu__catalog-wrap">
        <mobile-menu-catalog @openCatalog="openCatalog()"></mobile-menu-catalog>
      </div>
      <inner-level-menu
        :title="innerMenuTitle"
        :content="innerMenuContent"
        :is-open="innerMenuOpen"
        @hideCurrLevel="hideCatalog"
      ></inner-level-menu>
      <mobile-menu-list></mobile-menu-list>
      <mobile-menu-contacts></mobile-menu-contacts>
    </div>
    <div v-if="isVisible" @click="handleMenuBtnClick(false)" class="mobile-menu__backlayer"></div>
  </div>
</template>

<script>
import MobileMenuProfile from '@/components/header/MobileMenuProfile.vue'
import MobileMenuLanguage from '@/components/header/MobileMenuLanguage.vue'
import MobileMenuCatalog from '@/components/header/MobileMenuCatalog.vue'
import InnerLevelMenu from '@/components/header/InnerLevelMenu.vue'
import MobileMenuList from '@/components/header/MobileMenuList.vue'
import MobileMenuContacts from '@/components/header/MobileMenuContacts.vue'
import { mapGetters } from 'vuex'
// import geoHeader from '@/components/user-geo/GeoHeader.vue'

export default {
  name: 'MobileMenu',
  data () {
    return {
      isOpen: false,
      isVisible: false,
      innerMenuTitle: {},
      innerMenuContent: [],
      innerMenuOpen: false,
      menuHeight: '100dvh'
    }
  },
  props: {
    catalog: {
      type: Array,
      default: () => []
    }
  },
  components: {
    // geoHeader,
    MobileMenuProfile,
    MobileMenuLanguage,
    MobileMenuCatalog,
    InnerLevelMenu,
    MobileMenuList,
    MobileMenuContacts
  },
  methods: {
    getScreenHeight () {
      if (window.innerHeight) {
        this.menuHeight = window.innerHeight + 'px'
      }
    },
    hideCatalog () {
      this.innerMenuOpen = false
    },
    openCatalog () {
      this.innerMenuTitle = {
        text: this.$t('up.menu.catalog'),
        icon: '/img/svgo/header/mobile-catalog.svg'
      }
      this.innerMenuContent = this.catalog
      this.innerMenuOpen = true
    },
    disableScroll () {
      const scrollY = window.scrollY
      document.body.style.position = 'fixed'
      document.body.style.top = `-${scrollY}px`
      document.body.style.width = '100%'
      document.body.dataset.scrollY = scrollY
      document.body.classList.add('no-scroll')
    },
    enableScroll () {
      const scrollY = document.body.dataset.scrollY
      document.body.style.position = ''
      document.body.style.top = ''
      document.body.style.width = ''
      document.body.classList.remove('no-scroll')
      window.scrollTo(0, parseInt(scrollY || '0'))
    },
    handleMenuBtnClick (needOpen) {
      if (needOpen) {
        this.disableScroll()
        this.isVisible = true
        setTimeout(() => {
          this.isOpen = true
        }, 10)
      } else {
        this.enableScroll()
        this.isOpen = false
        setTimeout(() => {
          this.isVisible = false
          this.innerMenuTitle = {}
          this.innerMenuContent = []
          this.innerMenuOpen = false
        }, 400)
      }
    }
  },
  computed: {
    ...mapGetters(['urlLanguagePrefix', 'isUkLanguage'])
  },
  mounted () {
    this.getScreenHeight()
    window.addEventListener('resize', this.getScreenHeight)
  },
  beforeDestroy () {
    window.removeEventListener('resize', this.getScreenHeight)
  }
}
</script>

<style lang="sass">
body.no-scroll
  overscroll-behavior: none
  touch-action: none
  overflow: hidden
</style>
<style lang="sass" scoped>
.mobile-menu
  display: flex
  &__geo-popup-wrap
    display: none
    +mmax(1024)
      display: flex
  &__trigger
    flex-shrink: 0
    background: transparent
    border: none
    padding: 0
    margin: 0 20px 0 10px
    display: none
    align-items: center
    +mmax(1024)
      display: flex
  &__catalog-wrap
    padding: 0 15px
    margin-bottom: 8px
  &__logo
    width: 105px
    display: block
    font-size: 0
    img
      width: 100%
  &__language-wrap
    display: flex
    padding: 15px
    justify-content: space-between
    align-items: center
  &__backlayer
    position: fixed
    left: 0
    top: 0
    z-index: 14
    opacity: 0.5
    background: #000000
    width: 100%
    height: 100vh
    cursor: pointer
  &__wrapper
    position: fixed
    top: 0
    left: 0
    transform: translateX(-150%)
    display: flex
    flex-flow: column nowrap
    height: 100dvh
    max-width: 320px
    overflow-x: visible
    transition: transform 0.4s ease-in-out
    background-color: #fff
    z-index: 15
    width: calc(100vw - 60px)
    &-close
      position: absolute
      right: -46px
      top: 10px
      background: #FFFFFF url('/img/svgo/header/close-btn.svg') no-repeat center
      width: 30px
      height: 30px
      border: none
      border-radius: 50%
      pointer-events: none
    &--open
      transform: translateX(0)
</style>
